export default __webpack_public_path__ + "static/media/listing2.78f20e64.jpg";